import axios from 'axios';
import { AddOnsQueryFilters } from '../../features/addons/addonSlice';
import apiRequestHeaders from '../apiRequestHeaders';

export function fetchAllAddOns(filterRequest: AddOnsQueryFilters) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post('/addon/addons/getalladdons', filterRequest, config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAddonDefinitionDetails(addonId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { addonId },
  };

  return axios
    .get('/addon/addons/getaddondefinitiondetails', config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function updateAddonDefinition(accommodationAddonData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/addon/addons/updateaddondefinition', accommodationAddonData, config)
    .then(res => {
      return res.data;
    });
}

export function addAddonDefinition(accommodationAddonData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/addon/addons/addaddondefinition', accommodationAddonData, config)
    .then(res => {
      return res.data;
    });
}
